var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.37042 14.6184C1.5737 14.8221 1.85828 14.9444 2.14287 14.9444C2.42745 14.9444 2.69171 14.8425 2.91531 14.6184L7.99717 9.52529L13.079 14.6184C13.2823 14.8221 13.5669 14.9444 13.8515 14.9444C14.136 14.9444 14.4003 14.8425 14.6239 14.6184C15.0508 14.1906 15.0508 13.4979 14.6239 13.0905L9.54205 7.99736L14.6239 2.90426C15.0508 2.47644 15.0508 1.78378 14.6239 1.37633C14.197 0.948511 13.5262 0.948511 13.0993 1.37633L8.01749 6.46943L2.93564 1.37633C2.50876 0.948511 1.83795 0.948511 1.41108 1.37633C0.984203 1.80415 0.984203 2.49681 1.41108 2.90426L6.49294 7.99736L1.41108 13.0905C0.943548 13.5183 0.943548 14.1906 1.37042 14.6184Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIc);
export default __webpack_public_path__ + "static/media/cross-ic.dfcd1d05c523c828099346a9d14c7068.svg";
export { ForwardRef as ReactComponent };